import dayjs from "dayjs";

/** Keep in sync with backend `consultationDateValidation.js` */
export const MAX_CONSULTATION_BACKDATE_DAYS = 30;

export const isBackdatedConsultationDate = (dateStr) => {
  if (!dateStr) return false;
  const today = dayjs().format("YYYY-MM-DD");
  const d =
    typeof dateStr === "string"
      ? dateStr.slice(0, 10)
      : dayjs(dateStr).format("YYYY-MM-DD");
  return d < today;
};

/**
 * @param {boolean} allowsBackdate - from visit type master
 */
export const getConsultationDatePickerBounds = (allowsBackdate) => {
  const maxDate = dayjs().endOf("day");
  if (allowsBackdate) {
    return {
      minDate: dayjs()
        .subtract(MAX_CONSULTATION_BACKDATE_DAYS, "day")
        .startOf("day"),
      maxDate,
    };
  }
  return {
    minDate: dayjs().startOf("day"),
    maxDate,
  };
};

export const validateConsultationDateClient = ({
  consultationDate,
  allowsBackdate,
  backdateReason,
  appointmentDateStr,
}) => {
  if (!consultationDate) {
    return { ok: false, message: "Please select consultation date and time." };
  }

  const dateOnly = dayjs(consultationDate).format("YYYY-MM-DD");
  const today = dayjs().format("YYYY-MM-DD");

  if (dateOnly > today) {
    return { ok: false, message: "Consultation date cannot be in the future." };
  }

  if (dateOnly === today) {
    return { ok: true };
  }

  const daysBack = dayjs(today).diff(dayjs(dateOnly), "day");
  if (daysBack > MAX_CONSULTATION_BACKDATE_DAYS) {
    return {
      ok: false,
      message: `Consultation date cannot be more than ${MAX_CONSULTATION_BACKDATE_DAYS} days in the past.`,
    };
  }

  if (!(backdateReason && String(backdateReason).trim())) {
    return {
      ok: false,
      message: "Reason is required for backdated consultations.",
    };
  }

  const allowsViaAppointment =
    appointmentDateStr &&
    dayjs(appointmentDateStr).format("YYYY-MM-DD") === dateOnly;

  if (allowsBackdate || allowsViaAppointment) {
    return { ok: true };
  }

  return {
    ok: false,
    message:
      "Backdated date requires a visit type enabled for backdating, or the original appointment date.",
  };
};
